// import Gratification from "../../modules/gratification/Gratification.vue";
import RouterViewRender from "../../utils/routes/router-view-render";

const GratificationRoutes = {
  path: "gratificacao",
  redirect: "/inicio",
  component: RouterViewRender,
  children: [
    {
      path: "",
      redirect: "/inicio",
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default GratificationRoutes;
